import { PRODUCT_TAB_PLACEHOLDERS, ProductTabKey } from './productTabConfig';
import './ProductTabBar.css';

type PlaceholderTab = keyof typeof PRODUCT_TAB_PLACEHOLDERS;

interface ProductTabPlaceholderProps {
  tab: PlaceholderTab | ProductTabKey;
  requireSave?: boolean;
}

function ProductTabPlaceholder({ tab, requireSave = false }: ProductTabPlaceholderProps) {
  const meta =
    tab in PRODUCT_TAB_PLACEHOLDERS
      ? PRODUCT_TAB_PLACEHOLDERS[tab as PlaceholderTab]
      : { title: '준비 중', description: '추후 구성됩니다.' };
  return (
    <div className="product-tab-placeholder">
      <h3>{meta.title}</h3>
      <p>
        {requireSave
          ? '제품을 먼저 저장한 뒤 이 탭을 이용할 수 있습니다.'
          : meta.description}
      </p>
    </div>
  );
}

export default ProductTabPlaceholder;
